/**
 * @generated SignedSource<<a14ffd1f181f01b6b02338dbc132a520>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "attachmentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LegalContractMutationGroup",
    "kind": "LinkedField",
    "name": "legalContract",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "attachmentId",
                "variableName": "attachmentId"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "LegalContractModifyPayload",
        "kind": "LinkedField",
        "name": "importContractData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LegalContract",
            "kind": "LinkedField",
            "name": "legalContract",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DataImporterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DataImporterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f7616f1af8347eba4d05396d08920f0",
    "id": null,
    "metadata": {},
    "name": "DataImporterMutation",
    "operationKind": "mutation",
    "text": "mutation DataImporterMutation(\n  $attachmentId: ID!\n) {\n  legalContract {\n    importContractData(input: {attachmentId: $attachmentId}) {\n      legalContract {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f65c62c3d208faeccc4b88d1509464e9";

export default node;
